
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import GeneralRoutes from './GeneralRoutes';
import ClientDomainRouter from './ClientDomainRouter';
import SubscriptionPage from '../subscription/landing_page/SubscriptionPage';

export default function AppRouter() {
    return (
        // an early implementation of react v7
        <BrowserRouter future={{v7_startTransition: true,v7_relativeSplatPath: true,}}> 
            <Routes>
                <Route path="/">
                    {/* holds the first landing page */}
                    <Route index element={<SubscriptionPage/>}/>
                    {/* holds all the client pages and dashboard page */}
                    <Route path='*' element={<ClientDomainRouter/>}/>
                </Route>
                {/* holds the subscription process pages, signin page and admin page */}
                <Route path="/webingo/">
                    <Route index element={<GeneralRoutes/>}/>
                    <Route path='*' element={<GeneralRoutes/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}